import { CustomersDto } from '@/src/models/CustomersDto';
import EntryDto from '@/src/models/EntryDto';

export default class EntryParticipantsDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  entryCredit: number;
  isWinner: boolean;
  entry: EntryDto;
  customer: CustomersDto;
}
